export default __webpack_public_path__ + "static/sat-3b10ab9d35b42991d64ca7241e8574bc.png";